<!-- SIDE PANEL -->
<ng-container *ngIf="!fuseConfig.layout.sidepanel.hidden && fuseConfig.layout.sidepanel.position === 'left'">
  <!-- PANEL CONTENT -->
</ng-container>
<!-- / SIDE PANEL -->

<div id="main" [style.padding-top]="fuseConfig.layout.toolbar.hidden ? '0' : '64px'">
  <!-- TOOLBAR: Above -->
  <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'above'">
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  </ng-container>
  <!-- / TOOLBAR: Above -->

  <div id="container-1" class="container">
    <!-- NAVBAR: Left -->
    <ng-container *ngIf="fuseConfig.layout.navbar.position === 'left'">
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    </ng-container>
    <!-- / NAVBAR: Left -->

    <div id="container-2" class="container">
      <!-- TOOLBAR: Below fixed -->
      <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'below-fixed'">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      </ng-container>
      <!-- / TOOLBAR: Below fixed -->

      <div
        id="container-3"
        class="container"
        fusePerfectScrollbar
        [fusePerfectScrollbarOptions]="{ suppressScrollX: true, updateOnRouteChange: true }"
      >
        <!-- TOOLBAR: Below static -->
        <ng-container *ngIf="fuseConfig.layout.toolbar.position === 'below-static'">
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        </ng-container>
        <!-- / TOOLBAR: Below static -->

        <!-- CONTENT -->
        <content></content>
        <!-- / CONTENT -->

        <!-- FOOTER: Below static -->
        <ng-container *ngIf="fuseConfig.layout.footer.position === 'below-static'">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </ng-container>
        <!-- / FOOTER: Below static -->
      </div>
    </div>
  </div>

  <!-- FOOTER: Above -->
  <ng-container *ngIf="fuseConfig.layout.footer.position === 'above'">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </ng-container>
  <!-- FOOTER: Above -->
</div>

<ng-container *ngIf="!fuseConfig.layout.sidepanel.hidden && fuseConfig.layout.sidepanel.position === 'right'">
</ng-container>

<fuse-sidebar name="quickPanel" position="right" class="quick-panel">
  <quick-panel></quick-panel>
</fuse-sidebar>

<ng-template #toolbar>
  <fc-toolbar
    *ngIf="!fuseConfig.layout.toolbar.hidden"
    class="fuse-white-bg"
    [class]="fuseConfig.layout.toolbar.position"
    [user]="user"
    [environment]="environment"
    [unreadNotificationsCount]="unreadNotificationsCount | badge"
  >
  </fc-toolbar>
</ng-template>

<ng-template #footer>
  <footer *ngIf="!fuseConfig.layout.footer.hidden" [class]="fuseConfig.layout.footer.position"></footer>
</ng-template>

<ng-template #leftNavbar>
  <fce-sidebar
    [style.width.px]="sidebarOpen ? 240 : 64"
    *ngIf="!fuseConfig.layout.navbar.hidden"
    [project]="'mountdoom'"
    [language]="language"
    [account]="account"
    [permissions]="permissions"
    [environment]="environment"
    [user]="user"
    [isLoading]="false"
    [unreadNotificationsCount]="unreadNotificationsCount | badge"
    (toggleSidebar)="toggleSidebar($event)"
  >
  </fce-sidebar>
</ng-template>
